import { ESnapshotExists, ETemplate } from '../../types';
import { PublisherPaginationSettings } from '../../types/publisherPaginationSettings';
import { wrapError, wrapSuccess } from '../../types/responses';
import { mapAsync } from '../../helpers/array/async';
import { getFillerHeightInPixels } from './aspectRatioHelpers';

export const getHeaderSettingsForAutoPaginationRequest = async (
  publisherPaginationSettings: ESnapshotExists<PublisherPaginationSettings>,
  template: ESnapshotExists<ETemplate>
) => {
  const { headerSettings } = publisherPaginationSettings.data();
  if (!headerSettings) {
    return wrapSuccess(null);
  }
  if (!headerSettings.headers.length) {
    return wrapSuccess(null);
  }
  const templateStyles = template.data().styles;
  if (!templateStyles) {
    return wrapError(new Error('Template styles not found'));
  }
  const [headerErrors, headersWithHeight] = await mapAsync(
    headerSettings.headers,
    async header => {
      const [headerWithHeightError, headerWithHeight] =
        await getFillerHeightInPixels(header.url, header.width, templateStyles);
      if (headerWithHeightError) {
        return wrapError(headerWithHeightError);
      }
      return wrapSuccess({
        ...header,
        height: headerWithHeight
      });
    }
  );
  if (headerErrors) {
    return wrapError(headerErrors);
  }
  return wrapSuccess({
    headers: headersWithHeight
  });
};
